// import EascService from './Easc'

const clearLoginInfo = () => {
  app.$store.dispatch('fullToken', null)
  app.$store.dispatch('loginTips', true)
  app.$store.dispatch('hasLogin', false)
  localStorage.clear()
  document.location.href = '/#/login'
  // document.location.href = `${
  //   currentEnv.VUE_APP_EASC_PAGE
  // }/#/login?callbackUrl=${encodeURIComponent(window.location.href)}`
}

const errorMsgWhiteList = Wiz.globalSettings.globalConfig?.errorMsgWhiteList || []
console.log('errorMsgWhiteList*********', errorMsgWhiteList)
const MessageError = (message) => {
  console.log('message________', message)
  if (!errorMsgWhiteList.includes(Wiz.router.currentRoute.path)) {
    console.log('%^%^%^%^%^')
    app.$message.error(message)
  }
}

const errorHandle = async (err, status, data) => {
  const errInfo = err.response
  if (_.includes([401, 403], status)) {
    const refreshToken = localStorage.getItem('accessToken')
    if (!refreshToken) {
      app.$message.warning('请先登录。')
      return clearLoginInfo()
    }
    // const refreshRes = await EascService.refreshToken({
    //   refreshToken,
    // })
    const res = await axios.post(
      `${currentEnv.VUE_APP_DIY_SERVER}/api/SysUser/GetCurrentUser`,
      {},
      {
        headers: { Authorization: refreshToken },
      }
    )
    if (res.data && res.data.Code === 1) {
      localStorage.setItem('CurrentUser', JSON.stringify(res.data.Data))
      // const resData = res.data.Data
      const fullToken = `Bearer ${res.headers.authorization}`
      localStorage.setItem('fullToken', fullToken)
      localStorage.setItem('accessToken', res.headers.authorization)
      axios.defaults.headers.common.Authorization = fullToken
      app.$store.dispatch('fullToken', fullToken)
      app.$store.dispatch('hasLogin', true)
      const instance = axios.create({
        headers: {
          'Content-Type': errInfo.config.headers['Content-Type'],
        },
      })
      let againRes = null
      if (errInfo.config && errInfo.config.method === 'get') {
        const newRes = await axios.get(errInfo.config.url)
        if (newRes && newRes.data) {
          againRes = newRes.data
        } else {
          clearLoginInfo()
        }
      } else if (errInfo.config && errInfo.config.method === 'post') {
        const newRes = await instance.post(errInfo.config.url, errInfo.config.data)
        if (newRes && newRes.data) {
          againRes = newRes.data
        } else {
          clearLoginInfo()
        }
      } else if (errInfo.config && errInfo.config.method === 'patch') {
        const newRes = await instance.patch(errInfo.config.url, errInfo.config.data)
        if (newRes && newRes.data) {
          againRes = newRes.data
        } else {
          clearLoginInfo()
        }
      }
      // console.log('againRes', againRes)
      return againRes
    }
    return clearLoginInfo()
  }
  if (status === 404) {
    // return app.$message.error('请求的资源不存在')
    return MessageError('请求的资源不存在')
  }
  if (status === 400) {
    // return app.$message.error(data.msg)
    return MessageError(data.msg)
  }
  if (data.code === 1) {
    // return app.$message.error(data.msg)
    return MessageError(data.msg)
  }
  // console.log('err', err, status, data)
  // return app.$message.error(err.message || err.msg || data.msg)
  return MessageError(err.message || err.msg || data.msg)
}
export default (err, res) => {
  // console.log('service callback err res', err, res)
  if (err) {
    const info = JSON.parse(JSON.stringify(err))
    // console.log('service callback', info)
    if (info && info.response) {
      return errorHandle(err, info.response.status, info.response.data)
    }
  }
  if (res && res.data.code) {
    // app.$message.error(res.data.msg || res.data.message)
    MessageError(res.data.msg || res.data.message)
    return {
      code: res.data.code,
      data: res.data.data,
      message: res.data.msg,
      url: res.data.url,
    }
  }
  return res ? res.data : null
}
